// import { css } from '@emotion/react';
import styled from "@emotion/styled";

import { colors } from "../../colors";
import type {
  StyledDescriptionProps,
  StyledInputAreaProps,
  StyledLabelProps,
  StyledSettingWrapperProps,
} from "./types";

export const Container = styled.div<StyledSettingWrapperProps>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  background: ${({ $styleProps }) =>
    $styleProps?.containerBackgroundColor ?? "transparent"};
  border: ${({ $styleProps }) =>
    $styleProps?.containerBorderColor
      ? `1px solid ${$styleProps.containerBorderColor}`
      : "none"};
  border-radius: ${({ $styleProps }) =>
    $styleProps?.containerBorderRadius ?? "0"};
  padding: ${({ $styleProps }) => $styleProps?.containerPadding ?? "0"};
  opacity: ${({ $disabled }) => ($disabled ? "0.6" : "1")};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.label<StyledLabelProps>`
  font-size: 1.1em;
  font-weight: 600;
  line-height: 1.4;
  color: ${({ $styleProps }) => $styleProps?.labelColor ?? colors.gray[800]};
  margin: 0;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};

  /* Allow the label to wrap if it's too long */
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const Description = styled.p<StyledDescriptionProps>`
  font-size: 1em;
  font-weight: 400;
  line-height: 1.5;
  color: ${({ $styleProps }) =>
    $styleProps?.descriptionColor ?? colors.gray[600]};
  margin: 10px 0 0;

  /* Allow the description to wrap and handle long text gracefully */
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const InputArea = styled.div<StyledInputAreaProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: ${({ $styleProps }) =>
    $styleProps?.inputAreaBackgroundColor ?? "transparent"};
  border: ${({ $styleProps }) =>
    $styleProps?.inputAreaBorderColor
      ? `1px solid ${$styleProps.inputAreaBorderColor}`
      : "none"};
  border-radius: ${({ $styleProps }) =>
    $styleProps?.inputAreaBorderRadius ?? "6px"};
  padding: ${({ $styleProps }) => $styleProps?.inputAreaPadding ?? "0"};
  max-width: ${({ $styleProps }) => $styleProps?.inputAreaMaxWidth ?? "100%"};

  /* Ensure input components fill the available space */
  > * {
    width: 100%;
  }

  /* Handle nested flex containers */
  > div[class*="Container"] {
    width: 100%;
  }
`;
